export const SMS_CODE_LENGTH = 6;
export const ERROR_MESSAGE_PIN_LENGTH = "Код должен состоять из 6 цифр";

export const CHECK_SMS_FORM_KEYS = {
  smsCodeInvestor: "smsCodeInvestor",
} as const;
